import { Tag, Copy, Check } from "lucide-react";

/**
 * CouponGrid — renders the "Active deals" section on /u/:slug legacy
 * fallback. Tapping a coupon copies its code + fires a redeem event.
 * Parent owns `copiedCoupon` state so the checkmark reflects the right card.
 */
export function CouponGrid({ coupons, copiedCoupon, onRedeem }) {
  if (!coupons || coupons.length === 0) return null;
  return (
    <section data-testid="creator-directory-coupons-section">
      <p className="overline mb-3">
        <Tag className="w-3 h-3 inline mr-1" /> Active deals
      </p>
      <div className="grid gap-3 sm:grid-cols-2">
        {coupons.map((c, i) => {
          const copied = copiedCoupon === c.coupon_id;
          return (
            <button
              key={c.coupon_id}
              onClick={() => onRedeem(c)}
              className="text-left rounded-2xl p-4 transition-transform hover:-translate-y-[1px]"
              style={{
                background: "color-mix(in srgb, var(--ux-sun) 40%, white)",
                border: "1px solid var(--ux-border)",
                boxShadow: "var(--ux-shadow-1)",
              }}
              data-testid={`creator-directory-coupon-${i}`}
            >
              <div className="flex items-start justify-between gap-2 mb-2">
                <p className="font-bold text-sm truncate">
                  {c.headline || (c.discount_pct ? `${c.discount_pct}% off` : "Special deal")}
                </p>
                {copied ? (
                  <Check className="w-4 h-4 flex-shrink-0" />
                ) : (
                  <Copy className="w-4 h-4 flex-shrink-0" style={{ color: "var(--ux-ink-3)" }} />
                )}
              </div>
              {c.description && (
                <p className="text-xs mb-2" style={{ color: "var(--ux-ink-2)" }}>
                  {c.description}
                </p>
              )}
              <code
                className="block rounded-xl bg-white px-3 py-2 font-mono font-black text-lg tracking-widest text-center"
                style={{ border: "1px solid var(--ux-border)" }}
              >
                {c.code}
              </code>
              <p className="text-[10px] mt-1.5 text-center" style={{ color: "var(--ux-ink-3)" }}>
                {copied ? "Copied to clipboard" : "Tap to copy code"}
              </p>
            </button>
          );
        })}
      </div>
    </section>
  );
}
